module.exports = __webpack_public_path__ + "static/img/piece_2102.c6c2088.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/piece/piece_2102.png
// module id = qlGv
// module chunks = 0